import { Component, h, JSX } from 'preact';
import classNames from 'classnames';
import VideoEndScreenHtml from './html';
import VideoEndScreenImage from './image';
import VideoEndScreenAppPreview from './app-preview';
import cssStyles from './index.css';
import { EndScreenType } from '../../lib/end-screen/end-screen-types';
import { RootStore } from '../../../../common/js/stores/root.store';
import { EndScreen } from '../../lib/end-screen/end-screen';
import EndScreenVideo from '../../../../common/components/endscreen-video';

interface WindowSize {
  width: number;
  height: number;
}

interface VideoEndScreenProps {
  videoDuration: number;
  isMediumRectangleAdUnit: boolean;
  videoAspectRatio?: number;
  windowSize: WindowSize;
  shouldDisplaySkin: boolean;
  endScreen?: EndScreen;
  onClick?: (source: string, event?: MessageEvent) => void;
  onRendered?: () => void;
}

export default class VideoEndScreen extends Component<VideoEndScreenProps> {
  shouldComponentUpdate(nextProps: VideoEndScreenProps): boolean {
    return (
      nextProps.windowSize !== this.props.windowSize ||
      nextProps.endScreen !== this.props.endScreen
    );
  }

  displayEndScreenType(): JSX.Element | null {
    const { endScreen, videoDuration } = this.props;

    const mediaFile = RootStore.getInstance().videoStore.mediaFile.value;

    if (!endScreen) {
      return null;
    }

    switch (endScreen.type) {
      case EndScreenType.DEFAULT:
        return (
          <EndScreenVideo
            src={mediaFile?.url}
            mediaType={mediaFile?.type}
            videoCurrentTime={videoDuration}
            renderType={'fullScreen'}
          />
        );
      case EndScreenType.HTML:
      case EndScreenType.IFRAME:
        return (
          <VideoEndScreenHtml
            endScreen={endScreen}
            onClick={this.props.onClick}
          />
        );
      case EndScreenType.IMAGE:
        return (
          <VideoEndScreenImage
            isMediumRectangleAdUnit={this.props.isMediumRectangleAdUnit}
            endScreen={endScreen}
          />
        );
      case EndScreenType.APP_PREVIEW:
        return <VideoEndScreenAppPreview endScreen={endScreen} />;
      default:
        return null;
    }
  }

  render(): JSX.Element {
    const {
      isMediumRectangleAdUnit,
      videoAspectRatio = 16 / 9,
      windowSize,
      shouldDisplaySkin
    } = this.props;

    const isVideoCompleted = RootStore.getInstance().videoStore.isVideoCompleted
      .value;

    const styles = {
      mediumRectangleEndScreen: {
        top: isVideoCompleted ? '41px' : '-9999px'
      },
      endScreen: {
        height: shouldDisplaySkin
          ? windowSize.width * (1 / videoAspectRatio)
          : '100%'
      }
    };

    return (
      <div
        id={isVideoCompleted ? 'end_screen' : 'end_screen_placeholder'}
        style={
          isMediumRectangleAdUnit
            ? styles.mediumRectangleEndScreen
            : styles.endScreen
        }
        className={classNames({
          [cssStyles.endScreenContainer]: true,
          [cssStyles.endScreenMPU]: isMediumRectangleAdUnit
        })}
      >
        {this.displayEndScreenType()}
      </div>
    );
  }
}
